import { IsAlphanumeric, IsOptional, IsNumber, IsNotEmpty } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";

export class EducationIdRequest{
     @ApiProperty()
     @IsNotEmpty()
     @IsAlphanumeric()
     educationId: number;
    
     @ApiProperty()
     @IsOptional()
     updatedUser: string;
 
     @ApiProperty()
     @IsOptional()
     @IsNumber()
     versionFlag: number;
 
     @ApiProperty()
     isActive: boolean;

}